import { ObservatoryBundleItem } from "./queries";
import { Option } from "./components/SelectController";

export const mapBundleItemToOption = (
  item?: ObservatoryBundleItem
): Option | undefined => {
  if (!item) {
    return;
  }

  return {
    value: item.id,
    label: item.name,
  };
};
